import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class WhitelistTypes {
  static list: IActionType = new ActionType('WHITELIST/LIST');
  static updateWhitelist: IActionType = new ActionType('WHITELIST/UPDATE');
  static createWhitelist: IActionType = new ActionType('WHITELIST/CREATE');
  static deleteWhitelist: IActionType = new ActionType('WHITELIST/DELETE');
}

export default WhitelistTypes;
